// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from RatingNumber.module.scss  */
.RatingNumber-module-RatingNumber_FUe {
  display: inline-flex;
  align-items: center;
  font-size: 1rem; }

.RatingNumber-module-Value_wJL {
  margin-left: 0.25em;
  font-family: var(--rating-font-family);
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--rating-font-color); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Rating/Number/RatingNumber.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe,EAAE;;AAEnB;EACE,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B,EAAE","sourcesContent":["/*  imported from RatingNumber.module.scss  */\n.RatingNumber-module-RatingNumber_FUe {\n  display: inline-flex;\n  align-items: center;\n  font-size: 1rem; }\n\n.RatingNumber-module-Value_wJL {\n  margin-left: 0.25em;\n  font-family: var(--rating-font-family);\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--rating-font-color); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
